import React from 'react'
import classes from './Logo.module.css'
import logo from '../../assets/logo.png'
interface Props {
    style?: React.CSSProperties 
}

export const Logo: React.FC<Props> = (props) => {

    return (
        <img className={classes.logo} style={props.style} src={logo} alt='Logo' />
    )
}